export const GET_MARKETS = '/api/v1/market/p2p/v2/filter';
export const GET_TICKERS = '/api/v1/market/p2p/ticker';
export const GET_AGGTRADES = '/api/v1/market/p2p/aggTrades';
// Same image host as the wallet's (see BASE_URL_FOR_IMAGE).
export const SERVE_IMAGES = `${
  import.meta.env.VITE_IMAGE_BASE_URL || ''
}/api/v1/wallet/static/img`;
export const GET_P2P_MARKET_DEPTH = '/api/v1/market/p2p/depth';
export const ORDER_HISTORY = '/api/v1/financial-coordinator/p2p/order/history';
export const GET_OPEN_ORDERS = '/api/v1/financial-coordinator/p2p/order/open';
export const INIT_ORDER = '/api/v1/financial-coordinator/p2p/order/init';
export const GET_KLINE = '/api/v1/market/p2p/kline';
export const CANCEL_ORDER = '/api/v1/financial-coordinator/p2p/order/cancel';

/**
 * Column widths of the market-select list, as a grid template.
 *
 * SINGLE SOURCE OF TRUTH. The list is virtualized with react-window, so every
 * row renders as its own independent grid — the header and the rows have to be
 * handed the exact same track sizes or the columns visibly drift apart.
 *
 * The changes column is wider than a plain `1fr` because its heading reads
 * «تغییرات (۲۴h)», which wraps onto a second line in a narrower track and
 * overflows the fixed 40px header.
 */
export const MARKET_TABLE_GRID_COLUMNS = ['2fr', '1.6fr', '1.4fr'] as const;
